module.exports = __webpack_public_path__ + "static/media/menestras-del-negro.13badd4e.svg";